<button (click)="sendParent()" type="button" [disabled]="disabled">{{text}}</button>
